import type { AuthUser, EligibleGeoclient } from './api';

export const PROSPECTIVE_GEOCLIENT_SUFFIX = '_NB';

export function isNbaCalculatorAdmin(roles: AuthUser['roles']): boolean {
  return roles.includes('nbl_calculator_admin');
}

export function geoclientHasNbMarker(geoclient: { code?: string; name?: string }): boolean {
  const code = (geoclient.code || '').trim();
  const name = (geoclient.name || '').trim();
  return code.endsWith(PROSPECTIVE_GEOCLIENT_SUFFIX) || name.endsWith(PROSPECTIVE_GEOCLIENT_SUFFIX);
}

export function isNbaScopeGeoclient(geoclient: {
  code?: string;
  name?: string;
  clientStatus?: string;
}): boolean {
  const clientProspective = (geoclient.clientStatus || '').toLowerCase() === 'prospective';
  return clientProspective && geoclientHasNbMarker(geoclient);
}

export function nbaScopeGeoclientsForClient(user: AuthUser, clientId: string): EligibleGeoclient[] {
  return user.eligibleGeoclients.filter(
    (g) => g.clientId === clientId && isNbaScopeGeoclient(g),
  );
}

/** Platform admin, or New Business Admin on a prospective-client _NB geoclient only. */
export function canDeleteClientContent(user: AuthUser, clientId: string): boolean {
  if (user.permissions.canDeleteContent) return true;
  if (!isNbaCalculatorAdmin(user.roles)) return false;
  return nbaScopeGeoclientsForClient(user, clientId).length > 0;
}
